export const idlFactory = ({ IDL }: any) => {
  const TransactionType = IDL.Variant({
    decreaseLiquidity: IDL.Null,
    limitOrder: IDL.Record({
      token0InAmount: IDL.Nat,
      positionId: IDL.Nat,
      tickLimit: IDL.Int,
      token1InAmount: IDL.Nat,
    }),
    claim: IDL.Null,
    swap: IDL.Null,
    addLiquidity: IDL.Null,
    transferPosition: IDL.Nat,
    increaseLiquidity: IDL.Null,
  });
  const Transaction = IDL.Record({
    to: IDL.Text,
    action: TransactionType,
    token0Id: IDL.Text,
    token1Id: IDL.Text,
    liquidityTotal: IDL.Nat,
    from: IDL.Text,
    hash: IDL.Text,
    tick: IDL.Int,
    token1Price: IDL.Float64,
    recipient: IDL.Text,
    token0ChangeAmount: IDL.Float64,
    sender: IDL.Text,
    liquidityChange: IDL.Nat,
    token1Standard: IDL.Text,
    token0Fee: IDL.Float64,
    token1Fee: IDL.Float64,
    timestamp: IDL.Int,
    token1ChangeAmount: IDL.Float64,
    token1Decimals: IDL.Float64,
    token0Standard: IDL.Text,
    amountUSD: IDL.Float64,
    amountToken0: IDL.Float64,
    amountToken1: IDL.Float64,
    poolFee: IDL.Nat,
    token0Symbol: IDL.Text,
    token0Decimals: IDL.Float64,
    token0Price: IDL.Float64,
    token1Symbol: IDL.Text,
    poolId: IDL.Text,
  });
  const NatResult = IDL.Variant({ ok: IDL.Nat, err: IDL.Text });
  const RecordPage = IDL.Record({
    content: IDL.Vec(Transaction),
    offset: IDL.Nat,
    limit: IDL.Nat,
    totalElements: IDL.Nat,
  });
  return IDL.Service({
    addOwners: IDL.Func([IDL.Vec(IDL.Principal)], [], []),
    batchInsert: IDL.Func([IDL.Vec(Transaction)], [], []),
    cycleAvailable: IDL.Func([], [NatResult], []),
    cycleBalance: IDL.Func([], [NatResult], ["query"]),
    get: IDL.Func([IDL.Nat, IDL.Nat, IDL.Vec(IDL.Text)], [RecordPage], ["query"]),
    getByPool: IDL.Func([IDL.Nat, IDL.Nat, IDL.Text], [RecordPage], ["query"]),
    getByToken: IDL.Func([IDL.Nat, IDL.Nat, IDL.Text], [RecordPage], ["query"]),
    getByUser: IDL.Func([IDL.Nat, IDL.Nat, IDL.Principal, IDL.Text], [RecordPage], ["query"]),
    getFirstBlock: IDL.Func([], [IDL.Nat], ["query"]),
    getMine: IDL.Func([IDL.Nat, IDL.Nat, IDL.Text], [RecordPage], ["query"]),
    getOwners: IDL.Func([], [IDL.Vec(IDL.Principal)], []),
    getTx: IDL.Func([IDL.Nat, IDL.Nat], [RecordPage], ["query"]),
    getTxCount: IDL.Func([], [IDL.Nat], ["query"]),
    insert: IDL.Func([Transaction], [], []),
  });
};
